import * as Sentry from '@sentry/vue';
import { Web3ProviderEnum } from '../../types/enums';
import { web3ErrorToastMappings } from '@/js/store/web3/constants/error-messages/web3ErrorToastMappings';
import { getTrans } from '@/js/helpers/getTrans';
import { showToast } from '@/js/helpers/toastHelpers';

interface CustomError extends Error {
    response?: {
        data?: {
            message?: string;
        };
    };
}

export function handleWalletError(error: CustomError, wrapperName: string): void {
    const message = error?.message || '';
    const responseMessage = error?.response?.data?.message;
    const isCoinbaseEmptyError = wrapperName === Web3ProviderEnum.COINBASE && (!error || Object.keys(error).length === 0);

    if (isCoinbaseEmptyError) return;

    const matchedKey = Object.keys(web3ErrorToastMappings).find((key) => message.includes(key));
    const toastMessage = matchedKey
        ? web3ErrorToastMappings[matchedKey]
        : responseMessage || getTrans('quests-dashboard.somethingWentWrongToast', 'Something went wrong');

    if (!matchedKey) {
        Sentry.captureException(error);
    }

    showToast({ message: toastMessage });
}
